import * as types from "../constants/conference_constants";

const initialState = {
  data: null,
  conferenceError: null,
  register: null,
  message: null,
};

const conferenceReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.GET_CONFERENCE_SUCCESS:
      return {
        ...state,
        data: payload ? payload : null,
        conferenceError: null,
      };

    case types.CONFERENCE_PAYMENT_SUCCESS:
      return {
        ...state,
        data: payload ? payload : null,
        conferenceError: null,
      };

    case types.CONFERENCE_FACE_SUCCESS:
      return { ...state, message: payload ? payload : null };

    case types.CONFERENCE_NEEDS_SUCCESS:
      return { ...state, message: "Success", conferenceError: null };

    case types.CONFERENCE_MANUAL_SUCCESS:
    case types.CONFERENCE_RECEIPT_SUCCESS:
      return {
        ...state,
        data: payload ? payload : null,
        conferenceError: null,
      };

    case types.REGISTER_CONFERENCE_SUCCESS:
      return {
        ...state,
        data: payload ? payload : null,
        register: payload ? payload.conference[0] : null,
        conferenceError: null,
      };

    case types.REGISTER_CONFERENCE_FAILURE:
      return { ...state, conferenceError: payload ? payload : null };

    case types.GET_CONFERENCE_FAILURE:
    case types.CONFERENCE_PAYMENT_FAILURE:
    case types.CONFERENCE_MANUAL_FAILURE:
    case types.CONFERENCE_RECEIPT_FAILURE:
    case types.CONFERENCE_NEEDS_FAILURE:
    case types.CONFERENCE_FACE_FAILURE:
      return { ...state, conferenceError: payload ? payload : null };

    // case types.REGISTER_CONFERENCE_SUCCESS:
    //   return {
    //     ...state,
    //     reg_data: payload ? payload : null,
    //     reg_success: true,
    //   };

    default:
      return state;
  }
};

export default conferenceReducer;
